import React, { useState, useEffect, useCallback } from 'react'
import { DotButton, PrevButton, NextButton } from './emblaCarouselButtons'
import useEmblaCarousel from 'embla-carousel-react'
import Autoplay from 'embla-carousel-autoplay'

const EmblaCarousel = ({ children, options }) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(options, options?.autoplay && [Autoplay({ delay: options?.delayLength || 4000, stopOnInteraction: true, stopOnMouseEnter: true })])

  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false)
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false)
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState([])

  const scrollPrev = useCallback(() => emblaApi && emblaApi.scrollPrev(), [emblaApi])
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi])
  const scrollTo = useCallback((index) => emblaApi && emblaApi.scrollTo(index), [emblaApi])

  const onInit = useCallback((emblaApi) => {
    setScrollSnaps(emblaApi.scrollSnapList())
  }, [])

  const onSelect = useCallback((emblaApi) => {
    setSelectedIndex(emblaApi.selectedScrollSnap())
    setPrevBtnEnabled(emblaApi.canScrollPrev())
    setNextBtnEnabled(emblaApi.canScrollNext())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onInit(emblaApi)
    onSelect(emblaApi)
    emblaApi.on('reInit', onInit)
    emblaApi.on('reInit', onSelect)
    emblaApi.on('select', onSelect)
  }, [emblaApi, onInit, onSelect])

  return (
    <div className='embla group relative w-full'>
      <div className='embla__viewport overflow-hidden' ref={emblaRef}>
        <div className={`embla__container flex h-auto touch-pan-y flex-row ${scrollSnaps.length === 1 ? 'justify-center' : ''}`}>{children}</div>
      </div>

      {options?.dots && (
        <div className='mt-10 w-full text-center'>
          {scrollSnaps.map((_, index) => {
            if (scrollSnaps.length === 1) return null
            return <DotButton key={index} selected={index === selectedIndex} onClick={() => scrollTo(index)} />
          })}
        </div>
      )}
      {options?.arrows && (
        <>
          <PrevButton onClick={scrollPrev} enabled={prevBtnEnabled} />
          <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
        </>
      )}
    </div>
  )
}

export default EmblaCarousel
